import React from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

import { transformSlug } from "utils/Translations";

export function SlugProposition({
  disabled,
  label,
  placeholder,
  slug,
  slugPropositionChange,
}) {
  return (
    <div className="editor-form-input-slug-container">
      <p className="editor-form-input-placeholder-slug">{placeholder}</p>
      <input
        key={`${label}-value-slug`}
        id={`${label}-slug`}
        disabled={disabled}
        type="text"
        className="editor-form-input-title slug"
        value={slug || ""}
        maxLength={128}
        onChange={(e) => slugPropositionChange(transformSlug(e.target.value))}
      />
    </div>
  );
}

SlugProposition.propTypes = {
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  slug: PropTypes.string,
  slugPropositionChange: PropTypes.func.isRequired,
};

export default withTranslation(["languages"])(SlugProposition);
